export default __webpack_public_path__ + "static/107-3f5efcb17070a41661e3f6ed31d3a529.jpg";